import React, { useCallback, useEffect, useState } from 'react'
import DashboardService from '../../services/dashboard.service'
import { useSelector } from 'react-redux'
import { NavLink, useHistory } from 'react-router-dom'
import Layout from '../Layout/layout'
import { getRoleAccessKeySelector } from '../../store/selectors/app.selector'
import './dashboard.css'
import AdBanner from '../dashboard-header/adBanner'
import UserDetail from '../dashboard-header/userDetail'
import { useTranslation } from 'react-i18next'
import Side_DashboardIcon from 'custom/assets/side-bar/Dashboard_Sidebar.svg'
import { SIDE_NAV_KEYS } from '../../utils/translation-constants'

export default function Dashboard() {
  const roleAccessKey = useSelector(getRoleAccessKeySelector)
  const [userRoleList, setUserRoleList] = useState([])
  const [dashboardList, setDashboardList] = useState([])
  const { t } = useTranslation()

  useEffect(() => {
    getMenuOptions()
    return () => {}
  }, [roleAccessKey])

  const getMenuOptions = useCallback(async () => {
    try {
      const response = await DashboardService.getMenuDetails(roleAccessKey)
      if (response.status === 200) {
        setUserRoleList(response.data)
        setDashboardList(
          response.data.filter(
            (element) => !['DASHBOARD', 'ADDITIONAL_LINKS'].includes(element.key),
          ),
        )
      }
    } catch (err) {
      console.error(err)
    }
  }, [roleAccessKey])

  return (
    <Layout>
      <div className='dashboard-header-section'>
        <div className='row'>
          <div className='col-5'>
            <UserDetail />
          </div>
          <div className='col-7'>
            <AdBanner />
          </div>
        </div>
      </div>

      <div className='d-flex'>
        <div>
          <NavLink
            className='nav-card '
            key={0}
            activeClassName='nav-card-selected'
            to={'/dashboard'}>
            <img src={Side_DashboardIcon} />
            <h2>{t(SIDE_NAV_KEYS.DASHBOARD)}</h2>
          </NavLink>
          {userRoleList.map((role, index) => (
            <NavLink
              className='nav-card '
              key={index}
              activeClassName='nav-card-selected'
              to={role.link}>
              <img className='sidebar_menu_img' src={role.icon} />
              <h2>{t(role.title)}</h2>
            </NavLink>
          ))}
        </div>

        <div className='dashboard-section'>
          <div className='row d-flex'>
            {dashboardList.map((role, index) => (
              <NavLink className='menu-card-secondary' key={index} to={role.link}>
                <img width={55} height={55} src={role.dashIcon} />
                <h2 style={{marginTop:10}}>{t(role.title)}</h2>
              </NavLink>
            ))}
          </div>
        </div>

        {/* <div className='dashboard-section'>
          <div className='row d-flex'>
            {roleAccessKey === 'I' &&
              dashboardList.map((role, index) =>
                role.title === 'side_nav_portfolio' ? (
                  <div className='clo-4'>
                    <NavLink className='menu-card-account' key={index} to={role.link}>
                      <h2>{t(role.title)}</h2>
                      <h6>{t(role.desc)}</h6>
                      <img width={65} height={65} src={role.dashIcon} />
                    </NavLink>
                  </div>
                ) : role.title === 'side_nav_approvals' || role.title === 'side_nav_history' ? (
                  <div className='clo-4'>
                    <NavLink className='menu-card-tertiary' key={index} to={role.link}>
                      <h2>{t(role.title)}</h2>
                      <h6>{t(role.desc)}</h6>
                      <img width={65} height={65} src={role.dashIcon} />
                    </NavLink>
                  </div>
                ) : (
                  <div className='clo-4'>
                    <NavLink className='menu-card-secondary' key={index} to={role.link}>
                      <h2>{t(role.title)}</h2>
                      <h6>{t(role.desc)}</h6>
                      <img width={65} height={65} src={role.dashIcon} />
                    </NavLink>
                  </div>
                ),
              )}
            {roleAccessKey === 'AA' &&
              dashboardList.map((role, index) =>
                role.title === 'side_nav_portfolio' ? (
                  <div className='clo-4'>
                    <NavLink className='menu-card-account' key={index} to={role.link}>
                      <h2>{t(role.title)}</h2>
                      <h6>{t(role.desc)}</h6>
                      <img width={65} height={65} src={role.dashIcon} />
                    </NavLink>
                  </div>
                ) : role.title === 'side_nav_transfers' || role.title === 'side_nav_history' ? (
                  <div className='clo-4'>
                    <NavLink className='menu-card-tertiary' key={index} to={role.link}>
                      <h2>{t(role.title)}</h2>
                      <h6>{t(role.desc)}</h6>
                      <img width={65} height={65} src={role.dashIcon} />
                    </NavLink>
                  </div>
                ) : (
                  <div className='clo-4'>
                    <NavLink className='menu-card-secondary' key={index} to={role.link}>
                      <h2>{t(role.title)}</h2>
                      <h6>{t(role.desc)}</h6>
                      <img width={65} height={65} src={role.dashIcon} />
                    </NavLink>
                  </div>
                ),
              )}
            {(roleAccessKey === 'A' || roleAccessKey === 'VR' || roleAccessKey === 'VW') &&
              dashboardList.map((role, index) =>
                role.title === 'side_nav_portfolio' ? (
                  <div className='clo-4'>
                    <NavLink className='menu-card-account' key={index} to={role.link}>
                      <h2>{t(role.title)}</h2>
                      <h6>{t(role.desc)}</h6>
                      <img width={65} height={65} src={role.dashIcon} />
                    </NavLink>
                  </div>
                ) : role.title === 'side_nav_exchange_rates' ||
                  role.title === 'side_nav_other_services' ? (
                  <div className='clo-4'>
                    <NavLink className='menu-card-tertiary' key={index} to={role.link}>
                      <h2>{t(role.title)}</h2>
                      <h6>{t(role.desc)}</h6>
                      <img width={65} height={65} src={role.dashIcon} />
                    </NavLink>
                  </div>
                ) : (
                  <div className='clo-4'>
                    <NavLink className='menu-card-secondary' key={index} to={role.link}>
                      <h2>{t(role.title)}</h2>
                      <h6>{t(role.desc)}</h6>
                      <img width={65} height={65} src={role.dashIcon} />
                    </NavLink>
                  </div>
                ),
              )}
          </div>
        </div> */}
      </div>
    </Layout>
  )
}
